<!--
 * @Author: xiaokun
 * @Date: 2020-04-15 14:36:13
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-04 14:35:20
 * @Description: 关联任务 选择
 -->
<template>
  <div class="select-link-task">
    <!-- 关联任务 -->
    <mk-select
      v-model="curTaskIds"
      placeholder="选择关联任务"
      multiple
      clearable
      filterable
      width="200px"
      @change="onSelectChange"
    >
      <mk-option
        v-for="item in taskIdsOptions"
        :key="item._id"
        :label="item.name"
        :value="item._id"
      >
      </mk-option>
    </mk-select>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  model: {
    event: 'change', prop: 'taskIds'
  },
  props: {
    taskIds: {
      type: Array,
      default () {
        return []
      }
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      curTaskIds: this.taskIds,
      taskIdsOptions: []
    }
  },
  watch: {
    taskIds (val) {
      this.curTaskIds = val
    }
  },
  created () {
    this.missionListSimplePost(this.data.paperId)
  },
  methods: {
    // 获取关联任务
    async missionListSimplePost (paperId) {
      let ids = []
      ids.push(paperId)
      let res = await MBASVCAPIS.MissionApi.missionListSimplePost({ ids })
      if (res.success) {
        this.taskIdsOptions = res.data.data
      }
    },
    // 下拉框选择时候
    onSelectChange (val) {
      this.$emit('change', val)
    }
  }
}
</script>
<style scoped lang="scss">
.select-link-task {
  /deep/ .el-tag {
    max-width: 100%;
    display: flex;
    align-items: center;

    .el-select__tags-text {
      overflow: hidden;
      max-width: 88%;
      text-overflow: ellipsis;
      display: inline-block;
    }
  }

  /deep/ .el-input__inner {
    padding-right: 38px;
  }
}
</style>
